import { QuillModule } from 'ngx-quill';
import { CustomMaterialModule } from './../core/material.module';
import { UnitDetailsViewComponent } from './containers/unit-details-view.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ComponentsModule } from './components';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { reducers } from './reducers/index';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared-module/shared.module';
import { SettingsViewComponent } from './containers/settings-view.component';
import { UnitsEffects } from './effects/unit';
import { UnitService } from './services/unit';
import { UnitSettingsViewComponent } from './containers/unit-settings-view.component';
import { ModalService } from '../lib/services/modal.service';
import { CareerPageComponent } from './components/career-page/career-page.component';
import { BillingModule } from '../billing-module/billing.module';
import { BillingComponent } from '../billing-module/billing.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    SharedModule,
    BillingModule,
    RouterModule.forChild([
      {
        path: '',
        component: SettingsViewComponent,
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'unit-details',
          },
          {
            path: 'unit-details',
            component: UnitDetailsViewComponent,
            pathMatch: 'full',
          },
          {
            path: 'unit-settings',
            component: UnitSettingsViewComponent,
            pathMatch: 'full',
          },
          {
            path: 'career',
            component: CareerPageComponent,
            pathMatch: 'full',
          },
          {
            path: 'billing',
            component: BillingComponent,
            pathMatch: 'full',
          },
        ],
      },
    ]),
    StoreModule.forFeature('unit', reducers),
    EffectsModule.forFeature([UnitsEffects]),
    FlexLayoutModule,
    CustomMaterialModule,
    QuillModule,
  ],
  exports: [],
  declarations: [
    UnitDetailsViewComponent,
    SettingsViewComponent,
    UnitSettingsViewComponent,
  ],
  providers: [UnitService, ModalService],
})
export class SettingsModule {}
